import React from 'react';
import {Button} from 'semantic-ui-react';
import {withRouter} from 'react-router';
import {get as _get} from 'lodash';
import PropTypes from 'prop-types';

import DefaultForm from '@appComponents/DefaultForm';
import {getLink} from '@appComponents/Link';
import {setDefaultSuccessCallbacks} from '@utils/forms';
import {syncOriginEntryPointMultiselects} from '@utils/originEntryPointFormHelper';
import {
    handleAdSpliceConfigField,
    prepareDataForSubmitForm,
} from '@modules/srtOriginEntryPoint/utils/helpers';
import {dropdownOptionParser} from '@utils/dropdownOptionParser';

const SRT_ENTITY_KEY = 'srtOriginEntryPoint';

export class SrtOriginEntryPointForm extends DefaultForm {
    static propTypes = {
        client: PropTypes.object,
        history: PropTypes.object,
        formValues: PropTypes.object,
    };

    componentDidMount = () => {
        setDefaultSuccessCallbacks(this, () => {
            this.props.history.push(this.createLinkToIndexPage());
        });

        this.setOptionParsers({
            ad_splice_config: dropdownOptionParser,
        });
    };

    componentDidUpdate = (prevProps) => {
        super.componentDidUpdate(prevProps);
        handleAdSpliceConfigField(this, prevProps);

        if (!this.props.GraphQLOptionsData) {
            return;
        }

        syncOriginEntryPointMultiselects(this, SRT_ENTITY_KEY);
    };

    prepareDataForSubmit = (data) => {
        return prepareDataForSubmitForm(data, this.props.Model);
    };

    renderCancelButton = () => null;

    createLinkToIndexPage = () => (
        getLink('srtOriginEntryPoints.index')
    );

    renderErrors = () => {
        super.renderErrors(
            'The requested SRT origin entry point could not be found.',
            this.props.Model.entityLabel,
            this.createLinkToIndexPage()
        );
    };

    renderDeleteButton = () => {
        let deleteButton = null;
        const hasEventContentInputs = _get(this.props, 'GraphQLEntityData.srtOriginEntryPoint.has_event_content_inputs');

        if (false === hasEventContentInputs) {
            deleteButton =
                <Button onClick={ this.deleteButtonClick }
                    color='red'
                    disabled={ this.props.submitting }
                    icon='trash'
                    content='Delete'
                />;
        }

        return deleteButton;
    };
}

export default withRouter(SrtOriginEntryPointForm);
